// extracted by mini-css-extract-plugin
export default {"app":"_1X99PPGcn7","content":"_2oV8uPP0dj"};